import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import getValidColor from '../../lib/get-valid-color';
import { stringSelectSpec } from '../../lib/editing-configs';

import './row.scss';

const Row = ({
  id,
  className,
  children,
  backgroundColor,
  backgroundImage,
  paddingStyle,
  maxWidth,
  marginLeft,
  centeredInParent,
  standardMaxWidths,
  columns,
  dataIntegration,
  allowColumnsInMobile,
  style,
}) => {
  const styling = {
    backgroundColor: getValidColor(backgroundColor),
    backgroundImage: backgroundImage && `url(${backgroundImage})`,
    backgroundRepeat: backgroundImage && 'no-repeat',
    maxWidth,
    marginLeft,
    ...style,
  };

  const containerLayoutType = allowColumnsInMobile
    ? 'allow-mobile-column'
    : 'row-container';

  return (
    <div
      id={id}
      className={classNames([className, paddingStyle], {
        [`${containerLayoutType}-${columns}-col`]: columns,
        'centered-in-parent': centeredInParent,
        'landing-page-standard__max-widths': standardMaxWidths,
      })}
      style={styling}
      data-integration={dataIntegration}
    >
      {children}
    </div>
  );
};

Row.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
  paddingStyle: PropTypes.oneOf([
    '',
    'module-lg',
    'module-lg-skinny-bottom-mobile',
    'module-sm',
  ]),
  maxWidth: PropTypes.oneOf(['970px']),
  marginLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  standardMaxWidths: PropTypes.bool,
  centeredInParent: PropTypes.bool,
  columns: PropTypes.string,
  // apply layout in columns in mobile viewport despite de screen size
  allowColumnsInMobile: PropTypes.bool,
  // data attribute for integration tests to select on
  dataIntegration: PropTypes.string,
  style: PropTypes.object,
};

Row.displayName = 'Row';

Row.defaultProps = {
  id: null,
  className: null,
  children: null,
  paddingStyle: '',
  centeredInParent: false,
  columns: undefined,
  allowColumnsInMobile: false,
  style: {},
};

Row.getEditingConfig = () => [
  stringSelectSpec(
    'columns',
    'Number of columns',
    [
      {
        value: '',
        label: 'Auto',
      },
      {
        value: '1',
        label: '1',
      },
      {
        value: '2',
        label: '2',
      },
      {
        value: '3',
        label: '3',
      },
      {
        value: '4',
        label: '4',
      },
    ],
    {
      help: 'Number of columns in layout on desktop',
    }
  ),
];

export default Row;
